const merchants = [
  /*
  {
    name: 'Albertsons Irv9999 DS CA',
    logo: require('images/transaction-logos/albertsons.svg'),
    range: {
    min: 15,
    max: 100
  }
  },
  */
  {
    name: 'Amazon.com Fulfillment Ctr #88',
    logo: require('images/transaction-logos/amazon.svg'),
    range: {
      min: 10,
      max: 500
    }
  },
  {
    name: 'Apple Store (Neighborhood Mall #583)',
    logo: require('images/transaction-logos/apple.svg'),
    range: {
      min: 100,
      max: 1500
    }
  },
  {
    name: 'Chevron Store #75433',
    logo: require('images/transaction-logos/chevron.svg'),
    range: {
      min: 10,
      max: 60
    }
  },
  {
    name: 'Chipotle 3678 Coolville IL',
    logo: require('images/transaction-logos/chipotle.svg'),
    range: {
      min: 8,
      max: 50
    }
  },
  {
    name: 'Costco 443-C-332 Chicago IL',
    logo: require('images/transaction-logos/costco.svg'),
    range: {
      min: 40,
      max: 500
    }
  },
  {
    name: "Dominick's**453-53222 IL",
    logo: require('images/transaction-logos/dominicks.svg'),
    range: {
      min: 20,
      max: 120
    }
  },
  {
    name: 'Dunkin Donuts Evanston##4, IL',
    logo: require('images/transaction-logos/dunkin.svg'),
    range: {
      min: 4,
      max: 50
    }
  },
  {
    name: 'The Gap **OUTLET** $IL',
    logo: require('images/transaction-logos/gap.svg'),
    range: {
      min: 20,
      max: 120
    }
  },
  {
    name: 'Jimmy Johns Chicagoxx23 CA',
    logo: require('images/transaction-logos/jimmy-johns.svg'),
    range: {
      min: 8,
      max: 30
    }
  },
  {
    name: "Macy's Store 23739IL43",
    logo: require('images/transaction-logos/macys.svg'),
    range: {
      min: 30,
      max: 300
    }
  },
  {
    name: 'McDonalds 33-43432 Dine In Order',
    logo: require('images/transaction-logos/macdonalds.svg'),
    range: {
      min: 3,
      max: 30
    }
  },
  {
    name: 'Menards Retail 2188-3 Illinois',
    logo: require('images/transaction-logos/menards.svg'),
    range: {
      min: 30,
      max: 400
    }
  },
  {
    name: 'Nordstrom Woodfield Mall 63636',
    logo: require('images/transaction-logos/nordstrom.svg'),
    range: {
      min: 80,
      max: 400
    }
  },
  {
    name: 'Pizza Hut CO-IL-01222',
    logo: require('images/transaction-logos/pizza-hut.svg'),
    range: {
      min: 15,
      max: 80
    }
  },
  {
    name: 'Shell Gas 0043128 Carbondale, IL',
    logo: require('images/transaction-logos/shell.svg'),
    range: {
      min: 20,
      max: 60
    }
  },
  {
    name: 'Starbucks #2242 Schaumburg',
    logo: require('images/transaction-logos/starbucks.svg'),
    range: {
      min: 4,
      max: 20
    }
  },
  {
    name: 'Taco Bell 4423#IL',
    logo: require('images/transaction-logos/taco-bell.svg'),
    range: {
      min: 6,
      max: 20
    }
  },
  {
    name: 'Target Retail **65730**',
    logo: require('images/transaction-logos/target.svg'),
    range: {
      min: 40,
      max: 200
    }
  },
  {
    name: "TGI Friday's Dine In ##3333 IL",
    logo: require('images/transaction-logos/tgi-fridays.svg'),
    range: {
      min: 10,
      max: 50
    }
  },
  {
    name: 'Walmart Retail CD-58934',
    logo: require('images/transaction-logos/walmart.svg'),
    range: {
      min: 20,
      max: 150
    }
  },
  {
    name: 'Zara Store #98IL 336335',
    logo: require('images/transaction-logos/zara.svg'),
    range: {
      min: 20,
      max: 150
    }
  }
]

export default merchants
